<app-dc-header class="payloadHeader">
  <ng-container class="heading">Validate Payload </ng-container>
</app-dc-header>
<app-dc-pane class="payload" [noPadding]="true">
  <ng-container class="headingAction"
    ><button
      class="btn btn-sm btn-primary"
      type="submit"
      (click)="postPayload()"
      [disabled]="payloadForm.invalid"
    >
      Post
    </button>
  </ng-container>
  <ng-container class="heading">Payload</ng-container>
  <ng-container [formGroup]="payloadForm">
    <div class="formGrid">
      <app-dc-input
        type="text"
        formControlName="reference"
        class="referenceInput"
        placeholder="Reference"
      ></app-dc-input>
      <app-dc-textarea
        type="text"
        formControlName="payload"
        placeholder="Payload"
        class="payloadTextArea h-100"
      ></app-dc-textarea>
    </div>
  </ng-container>
</app-dc-pane>
<app-dc-pane [loading]="loading" class="payloadResults">
  <ng-container class="heading">Result</ng-container>
  <textarea
    name="resultValue"
    [(ngModel)]="result"
    readonly="true"
    class="form-control payloadResultsTextArea"
  ></textarea>
</app-dc-pane>
